interface InitOpenDecisionInput {
  pathname: string;
  hash: string;
  customerId?: number | string;
}

const NATIVE_STOREFRONT_PATH_SUFFIXES = ['/account.php', '/login.php'];

export function getClosestAnchorFromTarget(target: EventTarget | null): HTMLAnchorElement | null {
  if (!(target instanceof Element)) {
    return null;
  }

  return target.closest<HTMLAnchorElement>('a[href]');
}

export function getNativeStorefrontPath(
  href: string,
  origin = window.location.origin,
): string | null {
  try {
    const url = new URL(href, origin);

    if (url.origin !== origin) {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch (_error: unknown) {
    return null;
  }
}

export function isBuyerPortalNativeHref(href: string, origin = window.location.origin): boolean {
  const path = getNativeStorefrontPath(href, origin);

  if (!path) {
    return false;
  }

  // Match on the pathname only (strip search/hash) so a locale prefix like
  // /en/account.php still matches, while a query string that happens to
  // contain "account.php" (e.g. /search.php?search_query=account.php) can't.
  const pathname = path.split(/[?#]/)[0];

  return NATIVE_STOREFRONT_PATH_SUFFIXES.some((nativePath) => pathname.endsWith(nativePath));
}

export function shouldOpenAllowedPageOnInit({
  pathname,
  hash,
  customerId,
}: InitOpenDecisionInput): boolean {
  if (pathname.includes('checkout')) {
    return false;
  }

  if (pathname.includes('account.php') && !hash) {
    return true;
  }

  return !(customerId && !hash);
}
